import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row , Col, Table, Panel, Badge, ButtonGroup, Button, Glyphicon } from 'react-bootstrap';
import MathJax from 'react-mathjax-preview';
import { withRouter } from 'react-router';
import ReactStars from 'react-stars';

import { fetchErrorsFilter, deleteError, changeErrorMasterDegree } from '../actions/errorActions';
import { loginUser, logoutUser, registerUser } from '../actions/userActions';
import { fetchTagCounts } from '../actions/tagActions';
import { fetchSubjects } from '../actions/subjectActions';

/*const MathJax = require('@matejmazur/react-mathjax');*/
/*const MathJax = require('react-mathjax');*/

/*const ascii = '求以下函数的值：`U = 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))`';
const tex = '`f(x) = \\int_{-\\infty}^\\infty\\hat f(\\xi)\\,e^{2 \\pi i \\xi x}\\,d\\xi`'*/

class ErrorShow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      id: 0,
      ids: [],
      currentTags: [],
      currentSubjectId: 0,
    }
    this.tagClick = this.tagClick.bind(this);
    this.editClick = this.editClick.bind(this);
    this.deleteClick = this.deleteClick.bind(this);
    this.returnClick = this.returnClick.bind(this);
    this.masterDegreeClick = this.masterDegreeClick.bind(this);
    this.nextError = this.nextError.bind(this);
    this.prevError = this.prevError.bind(this);
  }

  componentDidMount() {
    let id = this.props.match.params.id;
    if(Object.keys(this.props.errors)!==0) {
      this.setState({ids:this.props.errors.map(e=>e.id)});
      let error = this.props.errors.find(e=>parseInt(e.id,0)===parseInt(id,0));
      if(error) {
        this.setState({error:error, id:id});
      }
    }
  }

  componentWillReceiveProps(newProps) {
    let id = this.props.match.params.id;
    if(Object.keys(newProps.errors)!==0) {
      this.setState({ids:newProps.errors.map(e=>e.id)});
      let error = newProps.errors.find(e=>parseInt(e.id,0)===parseInt(id,0));
      if(error) {
        this.setState({error:error,id:id});
      }
    }
  }

  tagClick(event) {
    event.preventDefault();
    /*console.log('tag clicked, id: '+event.target.id);*/
    this.props.history.push(`/errors/tag=`+event.target.id);
  }

  editClick(){
    this.props.history.push(`/erroredit/`+this.state.error.id);
  }

  returnClick() {
    this.props.history.push(`/errors/subject_`+this.state.error.subject);
  }

  deleteClick() {
    if (window.confirm("您要删除这道错题吗？") === true) {
      this.props.deleteError(this.props.userinfo.token, this.state.id);
      alert("删除成功。");
      this.props.fetchErrorsFilter(this.props.userinfo.token, 'subject='+this.state.error.subject);
      this.props.history.push(`/errors/subject=`+this.state.error.subject);
    }
  }

  masterDegreeClick(newRating) {
    if (window.confirm("您要更改这道错题的掌握程度吗？") === true) {
      if (parseInt(newRating,0)===5) {
        if (window.confirm("掌握程度改为5星后将不会在错题列表中显示，您确认要修改吗？")===true) {
          this.props.changeErrorMasterDegree(this.props.userinfo.token,this.state.id,newRating);
          this.props.fetchErrorsFilter(this.props.userinfo.token, 'subject='+this.state.error.subject);
          this.props.history.push(`/errors/subject=`+this.state.error.subject);
          alert('掌握程度已更改。');
        }
      } else {
        this.props.changeErrorMasterDegree(this.props.userinfo.token,this.state.id,newRating);
        this.props.fetchErrorsFilter(this.props.userinfo.token, 'subject='+this.state.error.subject);
        this.props.history.push(`/errors/subject=`+this.state.error.subject);
        alert('掌握程度已更改。');
      }
      
    }
  }

  nextError() {
    if (Object.keys(this.props.errors)!==0) {
      let ids = this.state.ids;
      let currentId = parseInt(this.state.id,0);
      let pos = ids.indexOf(currentId);
      if ((pos+1) < ids.length) {
        let newId = ids[pos+1];
        let error = this.props.errors.find(e=>parseInt(e.id,0)===parseInt(newId,0));
        this.setState({id:newId, error:error});
      } else {
        alert('已经是最后一个了。')
      }
    }
  }

  prevError() {
      if (Object.keys(this.props.errors)!==0) {
        let ids = this.state.ids;
        let currentId = parseInt(this.state.id,0);
        let pos = ids.indexOf(currentId);
        if (pos > 0) {
          let newId = ids[pos-1];
          let error = this.props.errors.find(e=>parseInt(e.id,0)===parseInt(newId,0));
          this.setState({id:newId, error:error});
        } else {
          alert('已经是第一个了。')
        }
      }
  }

  render() {
    var result = '';
    if ((this.state.id === 0) || (Object.keys(this.state.error) === 0) || (Object.keys(this.props.subjects)===0) || (Object.keys(this.props.tags)===0)) {
      result = <div><p>No data found.</p></div>
    } else {
      var subject_name = this.props.subjects.find(subject=>parseInt(subject.id,0)===parseInt(this.state.error.subject,0)).name;
      var tags = [];
      var hit_tags = this.props.tags.find(tag=>parseInt(tag.id,0)===parseInt(this.state.error.subject,0));
      if (hit_tags && 'tags' in hit_tags) {
        tags = this.props.tags.find(tag=>parseInt(tag.id,0)===parseInt(this.state.error.subject,0)).tags;
      }
      var tag_list = [];
      this.state.error.tags.forEach((tag)=>{
        var tt = tags.find(t=>parseInt(t.key,0)===parseInt(tag,0));
        if (tt) {
          tag_list.push(
            <a key={tt.key} id={tt.key} nohref="true"
              onClick={this.tagClick}>
              { tt.value }
              <Badge>
                { tt.count }
              </Badge>
            </a>
          )
        }
      })
      result =
        <Panel>
          <Panel.Heading>
            <h3>错题查看
              <ButtonGroup>
                <Button bsSize="xsmall" onClick={this.editClick}>
                  <Glyphicon glyph="pencil" title="编辑"/>
                </Button>
                <Button bsSize="xsmall" onClick={this.deleteClick}>
                  <Glyphicon glyph="remove" title="删除"/>
                </Button>
                <Button bsSize="xsmall" onClick={this.returnClick}>
                  <Glyphicon glyph="share-alt" title="返回" />
                </Button>
                <Button bsSize="xsmall" onClick={this.prevError}>
                  <Glyphicon glyph="menu-left" title="上一个" />
                </Button>
                <Button bsSize="xsmall" onClick={this.nextError}>
                  <Glyphicon glyph="menu-right" title="下一个" />
                </Button>
              </ButtonGroup>
            </h3>
          </Panel.Heading>
        <Panel.Body>
        <div>
        <Row className="error">
          <Col xs={12} md={4}>
            <div className="error" style={{border: "1px solid"}}>
              <Table striped bordered condensed hover>
              <tbody>
                <tr><td>错题科目：{subject_name}</td></tr>
                <tr><td>错题日期：{this.state.error.ddate}</td></tr>
                <tr><td>错题来源：{this.state.error.source}</td></tr>
                <tr><td>错题题型：{this.state.error.question_type}</td></tr>
                <tr><td>错题原因：{this.state.error.cause}</td></tr>
                <tr><td>掌握程度：
                  <ReactStars
                    count={5}
                    value={ this.state.error.master_degree }
                    onChange={ this.masterDegreeClick }
                    size={14}
                    color2={'#ffd700'}
                  />
                </td></tr>
              </tbody>
              </Table>
            </div>
          </Col>
          <Col xs={12} md={8}>
            <div className="error" style={{border: "1px solid", margin_left:"5px"}}>
              <Table  striped bordered condensed hover>
              <tbody>
                <tr><td>错题描述<br/>
                    {this.state.error.is_formula_in_question ? (<MathJax math={this.state.error.question_txt} />) : (<p>{this.state.error.question_txt}</p>)}
                    {typeof this.state.question_img1 !== "object" ? (<span><br/><img alt="" src={this.state.error.question_img1}/></span>):('')}
                    {typeof this.state.question_img2 !== "object" ? (<span><br/><img alt="" src={this.state.error.question_img2}/></span>):('')}
                </td></tr>
                <tr><td>我的答案<br/>
                <p style={{color:"red"}}>{this.state.error.error_answer_txt}</p>
                {this.state.error_answer_img1!==null ? (<span><br/><img alt="" src={this.state.error.error_answer_img1}/></span>):('')}
                {this.state.error_answer_img2!==null ? (<span><br/><img alt="" src={this.state.error.error_answer_img2}/></span>):('')}
                </td></tr>
                <tr><td>正确答案<br/>
                <p>{this.state.error.correct_answer_txt}</p>
                {this.state.correct_answer_img1!==null ? (<span><br/><img alt="" src={this.state.error.correct_answer_img1}/></span>):('')}
                {this.state.correct_answer_img2!==null ? (<span><br/><img alt="" src={this.state.error.correct_answer_img2}/></span>):('')}
                </td></tr>
                <tr><td>答题思路<br/><p>{this.state.error.method}</p></td></tr>
                <tr><td>知识点<br/>{ tag_list }</td></tr>
              </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
      </Panel.Body>
      </Panel>
    }
    return (result);
  }
}

ErrorShow.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  fetchTagCounts: propsTypes.func.isRequired,
  fetchSubjects: propsTypes.func.isRequired,
  fetchErrorsFilter: propsTypes.func.isRequired,
  deleteClick: propsTypes.func.isRequired,
  changeErrorMasterDegree: propsTypes.func.isRequired,
  subjects: propsTypes.list,
  errors: propsTypes.list,
  userinfo: propsTypes.object,
  tags: propsTypes.list,
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  subjects: state.subjects.items,
  tags: state.tags.items,
  errors: state.errors.items,
})


export default withRouter(
  connect(
    mapStateToProps,{
      loginUser, 
      logoutUser, 
      registerUser, 
      fetchTagCounts,
      fetchSubjects,
      fetchErrorsFilter,
      deleteError,
      changeErrorMasterDegree
    }
  )(ErrorShow)
);



// WEBPACK FOOTER //
// ./src/components/ErrorShow.js